import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import AppTheme from '../../libs/mui/AppTheme';
import type { ReactNode } from 'react';
import { useUserDataQuery } from '@shared/queries';
import { useAppNavigate } from '@shared/store';
import { AppRoutePath } from '@shared/AppRoutes';

type SideMenuListItemProps = {
  title: string;
  to: AppRoutePath | undefined;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  icon: ReactNode;
  isActive?: boolean;
  disabled?: boolean;
  id?: string;
};

const SideMenuButton = (props: SideMenuListItemProps) => {
  const { title, to, icon, isActive = false, disabled = false, onClick, id } = props;
  const navigate = useAppNavigate();
  const { data: userData } = useUserDataQuery();
  const colorScheme = userData?.colorScheme ?? AppTheme.palette.primary.main;

  return (
    <ListItem id={id} disablePadding sx={isActive ? { bgcolor: colorScheme, fontWeight: 700 } : {}}>
      <ListItemButton
        id={id}
        disabled={disabled}
        onClick={e => {
          onClick?.(e);
          if (to !== undefined) {
            navigate(to);
          }
        }}
        sx={
          isActive
            ? {
                color: 'common.white',
                '& .MuiListItemIcon-root': { color: 'common.white' },
              }
            : {}
        }
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
    </ListItem>
  );
};

export default SideMenuButton;
